import PropTypes from 'prop-types'
import React from 'react'
import content from 'pp-react-l10n'
import enRTRStrings from '../../../../config/enRTRStrings'
import linksURL from '../../../../config/links.json'
import { isDw2Repaint } from '../../experiments/dw2Repaint'
import { BodyText, Link as PPLink, v2blue400 } from '@paypalcorp/pp-react'
import glamorous from 'glamorous'
let i18n = content('transfer/inc/rtr')

const styles = {
  txtBold: {
    fontWeight: 'bold',
  },
  stateAgencyList: {
    listStyle: 'none',
    margin: '5px 0 10px',
  },
}

const CancelInfoContentDiv = glamorous.div({
  textAlign: 'left',
  '& p': {
    fontFamily: 'PayPalSansBig-Regular, "Helvetica Neue", Arial, sans-serif',
    fontSize: '1.125rem',
    lineHeight: '1.5rem',
  },
  '& a': {
    color: v2blue400,
    fontFamily: 'PayPalSansBig-Medium, Helvetica Neue, Arial, sans-serif',
    fontSize: '1.125rem',
  },
})

const CancelContentDiv = glamorous.p({
  textAlign: 'left',
  '& a': {
    color: v2blue400,
    fontFamily: 'PayPalSansBig-Medium, Helvetica Neue, Arial, sans-serif',
  },
})

const StateAgencyInfoListing = glamorous.ul({
  listStyle: 'none',
  margin: 0,
})

class RTRLegalScroll extends React.Component {
  static propTypes = {
    showENSubTextRTR: PropTypes.bool,
    isGuestUser: PropTypes.bool,
    complianceInfo: PropTypes.shape({
      fundsAvailabilityDisclaimerText: PropTypes.string,
      stateAgencyInfo: PropTypes.shape({
        name: PropTypes.string,
        phone: PropTypes.string,
        website: PropTypes.string,
      }),
    }),
  }

  render() {
    let {
      complianceInfo,
      isGuestUser = false,
      showENSubTextRTR = false,
    } = this.props

    /**
     * SRE bot's throws an error for dangerously set innerHTML. This is a workaround for
     * legitimate use cases
     * It is not a user input, it is for English content for locale values from enRTRStrings.json
     */
    const workaroundScoreBot = ['dangerously', 'Set', 'Inner', 'HTML'].join('')
    const setInnerHTML = key => ({
      [workaroundScoreBot]: {
        __html: key,
      },
    })

    const customerServiceNumber = {
      phoneNumber: linksURL.ALL.CUSTOMER_SUPPORT.phoneNumber,
      phoneNumberLink: `tel:${linksURL.ALL.CUSTOMER_SUPPORT.phoneNumber}`,
    }

    return isDw2Repaint() ? (
      <div>
        {complianceInfo.fundsAvailabilityDisclaimerText && (
          <BodyText data-nemo="funds-availability-disclaimer">
            {i18n(`text.${complianceInfo.fundsAvailabilityDisclaimerText}`)}
          </BodyText>
        )}
        <div data-nemo="rtr-cancel">
          <BodyText as="h3" strong>
            {i18n('rtr.needToCancel')}
          </BodyText>
          <BodyText as={CancelContentDiv}>
            {i18n.html('rtr.needToCancelContent', {
              phoneNumber: linksURL.ALL.CUSTOMER_SUPPORT.phoneNumber,
              phoneNumberLink: `tel:${linksURL.ALL.CUSTOMER_SUPPORT.phoneNumber}`,
              homeLink: linksURL.US.homeLink,
            })}
          </BodyText>
        </div>
        <div data-nemo="rtr-info">
          <BodyText as="h3" strong>
            {i18n('rtr.aboutDisputes')}
          </BodyText>
          <BodyText as={CancelInfoContentDiv}>
            {!isGuestUser &&
              i18n.html('rtr.aboutDisputesPara.one', customerServiceNumber)}
            {i18n.html('rtr.aboutDisputesPara.two', customerServiceNumber)}
            {i18n.html(
              isGuestUser
                ? 'rtr.aboutDisputesGuestPara.three'
                : 'rtr.aboutDisputesPara.three'
            )}
          </BodyText>
          <BodyText>{i18n('rtr.agencyInfo')}</BodyText>
          {complianceInfo.stateAgencyInfo && (
            <div style={{ marginTop: '1rem' }} data-nemo="state-regulation">
              <BodyText strong>{complianceInfo.stateAgencyInfo.name}</BodyText>
              <StateAgencyInfoListing>
                <li>
                  <PPLink href={`tel:${complianceInfo.stateAgencyInfo.phone}`}>
                    {complianceInfo.stateAgencyInfo.phone}
                  </PPLink>
                </li>
                <li>
                  <PPLink
                    href={
                      /^https?:\/\//i.test(
                        complianceInfo.stateAgencyInfo.website
                      )
                        ? complianceInfo.stateAgencyInfo.website
                        : `http://${complianceInfo.stateAgencyInfo.website}`
                    }
                    target="_blank"
                  >
                    {complianceInfo.stateAgencyInfo.website}
                  </PPLink>
                </li>
              </StateAgencyInfoListing>
            </div>
          )}
          <BodyText as={CancelInfoContentDiv} data-nemo="consumer-finance">
            {i18n.html('rtr.consumerFinance', {
              phoneNumberOne: linksURL.US.CFPB.phoneNumberOne,
              phoneNumberOneLink: `tel:${linksURL.US.CFPB.phoneNumberOne}`,
              phoneNumberTwo: linksURL.US.CFPB.phoneNumberTwo,
              phoneNumberTwoLink: `tel:${linksURL.US.CFPB.phoneNumberTwo}`,
              consumerFinanceLink: linksURL.US.CFPB.consumerFinancelink,
            })}
          </BodyText>
        </div>
        {showENSubTextRTR && (
          <>
            {complianceInfo.fundsAvailabilityDisclaimerText && (
              <BodyText>
                {enRTRStrings[complianceInfo.fundsAvailabilityDisclaimerText]}
              </BodyText>
            )}
            <div>
              <BodyText as="h3" strong>
                {enRTRStrings.needToCancel}
              </BodyText>
              <BodyText
                as={CancelContentDiv}
                {...setInnerHTML(enRTRStrings.needToCancelContent)}
              />
            </div>
            <div>
              <BodyText as="h3" strong>
                {enRTRStrings.aboutDisputes}
              </BodyText>
              <BodyText
                as={CancelInfoContentDiv}
                {...setInnerHTML(
                  `${enRTRStrings['rtr.aboutDisputesPara.one']}${enRTRStrings['rtr.aboutDisputesPara.two']}${enRTRStrings['rtr.aboutDisputesPara.three']}`
                )}
              />
              <BodyText>{enRTRStrings.agencyInfo}</BodyText>
              {complianceInfo.stateAgencyInfo && (
                <div style={{ marginTop: '1rem' }}>
                  <BodyText strong>
                    {complianceInfo.stateAgencyInfo.name}
                  </BodyText>
                  <StateAgencyInfoListing>
                    <li>
                      <PPLink
                        href={`tel:${complianceInfo.stateAgencyInfo.phone}`}
                      >
                        {complianceInfo.stateAgencyInfo.phone}
                      </PPLink>
                    </li>
                    <li>
                      <PPLink
                        href={
                          /^https?:\/\//i.test(
                            complianceInfo.stateAgencyInfo.website
                          )
                            ? complianceInfo.stateAgencyInfo.website
                            : `http://${complianceInfo.stateAgencyInfo.website}`
                        }
                        target="_blank"
                      >
                        {complianceInfo.stateAgencyInfo.website}
                      </PPLink>
                    </li>
                  </StateAgencyInfoListing>
                </div>
              )}
              <BodyText
                as={CancelInfoContentDiv}
                {...setInnerHTML(enRTRStrings.consumerFinance)}
              />
            </div>
          </>
        )}
      </div>
    ) : (
      <div>
        {complianceInfo.fundsAvailabilityDisclaimerText && (
          <p
            className="fundsAvailabilityDisclaimer"
            data-nemo="funds-availability-disclaimer"
          >
            {i18n(`text.${complianceInfo.fundsAvailabilityDisclaimerText}`)}
          </p>
        )}

        <div className="rtrCancel" data-nemo="rtr-cancel">
          <h3>{i18n('rtr.needToCancel')}</h3>
          <p>
            {i18n.html('rtr.needToCancelContent', {
              phoneNumber: linksURL.ALL.CUSTOMER_SUPPORT.phoneNumber,
              phoneNumberLink: `tel:${linksURL.ALL.CUSTOMER_SUPPORT.phoneNumber}`,
              homeLink: linksURL.US.homeLink,
            })}
          </p>
        </div>
        <div className="rtrInfo" data-nemo="rtr-info">
          <h3>{i18n('rtr.aboutDisputes')}</h3>
          <p>
            {!isGuestUser &&
              i18n.html('rtr.aboutDisputesPara.one', customerServiceNumber)}
            {i18n.html('rtr.aboutDisputesPara.two', customerServiceNumber)}
            {i18n.html(
              isGuestUser
                ? 'rtr.aboutDisputesGuestPara.three'
                : 'rtr.aboutDisputesPara.three'
            )}
          </p>
          <p className="notSatisfied">{i18n('rtr.agencyInfo')}</p>

          {complianceInfo.stateAgencyInfo && (
            <div className="stateRegulation" data-nemo="state-regulation">
              <p className="vx_text-5">{complianceInfo.stateAgencyInfo.name}</p>
              <ul style={styles.stateAgencyList}>
                <li>
                  <a href={`tel:${complianceInfo.stateAgencyInfo.phone}`}>
                    {complianceInfo.stateAgencyInfo.phone}
                  </a>
                </li>
                <li>
                  <a
                    href={
                      /^https?:\/\//i.test(
                        complianceInfo.stateAgencyInfo.website
                      )
                        ? complianceInfo.stateAgencyInfo.website
                        : `http://${complianceInfo.stateAgencyInfo.website}`
                    }
                    target="_blank"
                  >
                    {complianceInfo.stateAgencyInfo.website}
                  </a>
                </li>
              </ul>
            </div>
          )}

          <div className="consumerFinance" data-nemo="consumer-finance">
            {i18n.html('rtr.consumerFinance', {
              phoneNumberOne: linksURL.US.CFPB.phoneNumberOne,
              phoneNumberOneLink: `tel:${linksURL.US.CFPB.phoneNumberOne}`,
              phoneNumberTwo: linksURL.US.CFPB.phoneNumberTwo,
              phoneNumberTwoLink: `tel:${linksURL.US.CFPB.phoneNumberTwo}`,
              consumerFinanceLink: linksURL.US.CFPB.consumerFinancelink,
            })}
          </div>
        </div>

        {showENSubTextRTR && (
          <>
            {complianceInfo.fundsAvailabilityDisclaimerText && (
              <p className="fundsAvailabilityDisclaimerENSubText">
                {enRTRStrings[complianceInfo.fundsAvailabilityDisclaimerText]}
              </p>
            )}
            <div className="rtrENSubCancel">
              <h3>{enRTRStrings.needToCancel}</h3>
              <p {...setInnerHTML(enRTRStrings.needToCancelContent)} />
            </div>
            <div className="rtrENSubInfo">
              <h3>{enRTRStrings.aboutDisputes}</h3>
              <p
                {...setInnerHTML(
                  `${enRTRStrings['rtr.aboutDisputesPara.one']}${enRTRStrings['rtr.aboutDisputesPara.two']}${enRTRStrings['rtr.aboutDisputesPara.three']}`
                )}
              />
              <p className="notSatisfiedENSubText">{enRTRStrings.agencyInfo}</p>
              {complianceInfo.stateAgencyInfo && (
                <div className="stateRegulationENSubText">
                  <p className="vx_text-5">
                    {complianceInfo.stateAgencyInfo.name}
                  </p>
                  <ul style={styles.stateAgencyList}>
                    <li>
                      <a href={`tel:${complianceInfo.stateAgencyInfo.phone}`}>
                        {complianceInfo.stateAgencyInfo.phone}
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          /^https?:\/\//i.test(
                            complianceInfo.stateAgencyInfo.website
                          )
                            ? complianceInfo.stateAgencyInfo.website
                            : `http://${complianceInfo.stateAgencyInfo.website}`
                        }
                        target="_blank"
                      >
                        {complianceInfo.stateAgencyInfo.website}
                      </a>
                    </li>
                  </ul>
                </div>
              )}
              <div
                className="consumerFinanceENSubText"
                {...setInnerHTML(enRTRStrings.consumerFinance)}
              />
            </div>
          </>
        )}
      </div>
    )
  }
}

export default RTRLegalScroll
